import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

const hotArticleImages = [
  'https://readdy.ai/api/search-image?query=Abstract%20modern%20minimalist%20illustration%20with%20warm%20orange%20and%20teal%20accents%2C%20clean%20geometric%20composition%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20yet%20creative&width=280&height=280&seq=hot-article-0-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Modern%20digital%20technology%20abstract%20illustration%20with%20warm%20orange%20undertones%2C%20flowing%20lines%20and%20nodes%2C%20clean%20minimal%20composition%2C%20soft%20gradient%20background&width=280&height=280&seq=hot-article-1-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Abstract%20gaming%20and%20entertainment%20concept%20illustration%20with%20vibrant%20warm%20accents%2C%20dynamic%20shapes%20and%20energy%2C%20clean%20modern%20aesthetic%2C%20soft%20background&width=280&height=280&seq=hot-article-2-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Elegant%20financial%20and%20investment%20abstract%20illustration%20with%20warm%20orange%20and%20teal%20accents%2C%20rising%20curves%20and%20data%20elements%2C%20clean%20composition&width=280&height=280&seq=hot-article-3-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Career%20and%20professional%20growth%20abstract%20illustration%20with%20warm%20orange%20highlights%2C%20ascending%20geometric%20shapes%2C%20clean%20modern%20style%2C%20soft%20gradient&width=280&height=280&seq=hot-article-4-2026&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Travel%20and%20adventure%20abstract%20illustration%20with%20warm%20earthy%20tones%20and%20teal%20accents%2C%20flowing%20landscape%20shapes%2C%20clean%20minimal%20composition&width=280&height=280&seq=hot-article-5-2026&orientation=squarish',
];

export default function HotTopics() {
  const hotArticles = getHotArticles(6);

  return (
    <section className="py-14 bg-background-100">
      <div className="container-custom">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
              <i className="ri-fire-line text-accent-600 text-lg"></i>
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading">热门话题</h2>
              <p className="text-sm text-foreground-500">当前最受关注的内容</p>
            </div>
          </div>
          <Link
            to="/category/tech-discuss"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {hotArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all overflow-hidden flex"
            >
              <div className="flex-shrink-0 w-24 md:w-28 relative overflow-hidden">
                <img
                  src={hotArticleImages[idx] || hotArticleImages[0]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-3.5 min-w-0">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <span className="text-xs px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded font-medium">
                    {article.categoryName}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5 leading-snug">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-[10px]"></i>{article.readCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line text-[10px]"></i>{article.commentCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}